/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Bronze_Hen_BurnInputs */

const en_bright_bronze_hen_burn = /** @type {(inputs: Bright_Bronze_Hen_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Multiple Users`)
};

const de_bright_bronze_hen_burn = /** @type {(inputs: Bright_Bronze_Hen_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere Benutzer bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit Multiple Users" |
*
* @param {Bright_Bronze_Hen_BurnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_bronze_hen_burn = /** @type {((inputs?: Bright_Bronze_Hen_BurnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Bronze_Hen_BurnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_bronze_hen_burn(inputs)
	return de_bright_bronze_hen_burn(inputs)
});